import type { FaireProductEntity } from "../../entity_types/product";

export const p_cca44grfy4: FaireProductEntity = {
  token: "p_cca44grfy4",
  type: "product",
  name: "Swedish Dishcloth 3 Pack - Original Mixed Prints",
  brandToken: "b_bc5ff112",
  brandName: "Bee's Wrap",
  imageUrl:
    "https://cdn.faire.com/fastly/447d96353fb29ac047dff9c279ba06a1a82ac82656a100bba827fb5841c14a66.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3702356bbcee4b689d8b1430eacfd191c510f86055aa410515a2f87854e74b4c.png",
    "https://cdn.faire.com/fastly/20e1307e83df18067bd1a148c6530efad6b9ae7cd3abd006bba018f61c0223b1.png",
    "https://cdn.faire.com/fastly/c99c30f501cc0f20352bc4a253c8caff11e7750fff117ad75fdd0b136a7f55ca.png",
    "https://cdn.faire.com/fastly/5b00dd9f554bce821e19ebca4d51354e1c37829f9ee293fa751da84b3bf88777.png",
    "https://cdn.faire.com/fastly/527bb021ca605c117d4afa2c6326762184f22241614fdcd6de3be25b4ef2bb16.png",
    "https://cdn.faire.com/fastly/e825213c1a5442a48e54aa7d34dcfae0bc3853bd83cee0bbe70f79884e910898.png",
    "https://cdn.faire.com/fastly/33b12bd907f2784f8fc88ed6d45954300f24a414a29c5f4f50b153b880b9b98f.png",
    "https://cdn.faire.com/fastly/83cfd6757d7b8c03688c9ba8a5ce5ae4f5a09cff9396226e75ecccefa7b922a5.jpeg",
    "https://cdn.faire.com/fastly/1642143f1bda100c118c8e0fc0d0c1daf4c9dbbee217e5564261719368ed098d.png",
  ],
  priceDollars: 7.5,
  description:
    'Wipe down counters and clean up messes with this reusable, eco-friendly alternative to sponges and paper towels. Swedish Dishcloths are a reusable cellulose fiber cloth that can do the work of any kitchen sponge and replace up to 15 rolls of paper towels, making them a great eco-friendly sustainable choice!  They are machine washable or dishwasher safe, and can be reused again and again, when they wear out they can be composted, leaving without a trace.\n\nCloths are manufactured in Germany (made with the Swedish Process) and contain 70% cellulose and 30% cotton, designed and printed in the USA.  Ships with all other Bee\'s Wrap® items from our facility in Vermont.\n\nPack Includes:\n1 x Meadow Magic Dishcloth (6.75"w x 7.5"h)\n1 x Bees & Bears Dishcloth (6.75"w x 7.5"h)\n1 x Clover Dishcloth (6.75"w x 7.5"h)\n\nEnjoy this sustainable choice for Spring Cleaning or any time!\n\n#Spring Cleaning, Home, Kitchen, Sponge, Cleaning, Reusable, Eco Friendly\n',
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:31.409Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
